import React from "react";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import {setAdminLoginPopupVisible} from "./adminActions";
import WithOverlay from "../../popups/withOverlayHoc";
import LookInput from "../../look/ui/lookInput";
import {postLoginAdmin} from "../../../api/admin-api";
import LoadingSpinner from "../../ui/loadingSpinner";
import {getValidationErrors} from "../../look/user/lookUserInput";


const SuperAdminLoginPopup = (props) => {

  const {adminLoginPopupVisible, setAdminLoginPopupVisible} = props;

  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [errors, setErrors] = React.useState({});

  if (!adminLoginPopupVisible) {
    return null
  }

  const closeModal = () => {
    setAdminLoginPopupVisible(false);
  }

  const handleApply = async (apply, hideOverlay) => {
    if (apply) {
      setLoading(true);
      const loggedIn = await postLoginAdmin({email, password});
      setLoading(false);
      if (!loggedIn) {
        setErrors(Object.assign({}, {
          "email": ["look.inputs.errors.invalidEmail"],
          "password": ["look.inputs.errors.incorrectPassword"],
        }))
        return // do not close modal
      }
    }
    hideOverlay(closeModal);
  }

  return (
    <WithOverlay className="overlay--confirm">
      {(hideOverlay) => (
        <div className={"confirm-popup confirm-popup--message"}>
          <h3 className="ui-add-note margin-t-8">Super Admin Login</h3>
          <button className="apply-popup-header__close ui-close" onClick={() => hideOverlay(closeModal)}/>
          <LookInput property={"email"}
                     blockClassName={"width-100 max-280"}
                     inputsValidated={true}
                     inputValue={email}
                     setInputValue={(prop, val) => setEmail(val)}
                     errorsObject={errors}
                     getValidationErrors={getValidationErrors}
                     changeErrorsObject={setErrors}
                     isRequired={true} />
          <LookInput property={"password"}
                     blockClassName={"width-100 max-280 margin-b-8"}
                     inputsValidated={true}
                     inputValue={password}
                     setInputValue={(prop, val) => setPassword(val)}
                     errorsObject={errors}
                     getValidationErrors={getValidationErrors}
                     changeErrorsObject={setErrors}
                     isRequired={true} />
          <div className="confirm-popup-buttons">
            <button className="ui-button2 ui-button2--blue" onClick={() => handleApply(false, hideOverlay)}>
              <FormattedMessage id="confirmPopup.buttonCancel"/>
            </button>
            <button className="ui-button2 ui-button2--green" onClick={() => handleApply(true, hideOverlay)}>
              {loading ? <LoadingSpinner size="30"/> : <FormattedMessage id="userLoginButton.logIn"/>}
            </button>
          </div>
        </div>
      )}
    </WithOverlay>
  )
};

const mapStateToProps = (store) => {
  const {adminLoginPopupVisible} = store.adminState;
  return {
    adminLoginPopupVisible,
  };
};

const mapDispatchToProps = {
  setAdminLoginPopupVisible,
};

export default connect(mapStateToProps, mapDispatchToProps)(SuperAdminLoginPopup)
